@if (formattedTransaction()) {
  <div class="py-3">
    <!-- Transaction Header -->
    <div class="px-3">
      <h1 class="mb-0">{{ transactionType }} Details</h1>
      <h5 class="mb-2 transaction-amount" data-test="transaction-details-amount">
        {{
        formattedTransaction().amount
        | currency: formattedTransaction().currencyCountry
        }}
      </h5>
    </div>
    <!-- Transaction Details -->
    <div>
      <table class="table table-striped" style="table-layout: fixed">
        <tbody>
          @if (!shelper.isNullOrEmpty(formattedTransaction().operatorId)) {
            <tr>
              <td>{{ transactionType }} Completed By</td>
              <td>
                <strong [attr.data-user-id]="formattedTransaction().operatorId">{{
                  formattedTransaction().operatorName
                }}</strong>
              </td>
            </tr>
          }
          <tr>
            <td>{{ transactionType }} Date</td>
            <td>
              <strong>{{
                formattedTransaction().createdOn | date: 'dd/MM/yy HH:mm'
              }}</strong>
            </td>
          </tr>
          @if (!shelper.isNullOrEmpty(formattedTransaction().updatedOn)) {
            <tr>
              <td>Last Updated</td>
              <td>
                <strong>{{
                  formattedTransaction().updatedOn | date: 'dd/MM/yy HH:mm'
                }}</strong>
              </td>
            </tr>
          }
          <tr>
            <td>{{ transactionType }} Status</td>
            <td class="d-flex align-items-center justify-content-start">
              <odin-chip-status [icon]="formattedTransaction().isReversed ? 'restore' : undefined"
                [status]="formattedTransaction().formattedStatus"
              [chipClass]="formattedTransaction().statusIconClass"></odin-chip-status>
              <strong class="ms-2">{{
                formattedTransaction().formattedStatus
              }}</strong>
            </td>
          </tr>
          <tr>
            <td>{{ transactionType }} Type</td>
            <td class="d-flex align-items-center justify-content-start">
              <div style="width: 24px">
                <fa-icon class="d-block mx-auto" [icon]="transactionIcon(formattedTransaction())" size="lg"></fa-icon>
              </div>
              <strong class="ms-2">{{
                formattedTransaction().formattedChannel
              }}</strong>
            </td>
          </tr>
          <tr>
            <td>Payment Description</td>
            @if (showPaymentDescription()) {
              <td>
                <div class="d-flex align-items-center justify-content-start interactive">
                  <span>{{ formattedTransaction().paymentDetail }}</span>
                </div>
              </td>
            }
            @else {
              <td>
                <span>No description provided</span>
              </td>
            }
          </tr>
          <tr>
            <td>Currency</td>
            <td>
              <strong>{{ formattedTransaction().currencyCountry }}</strong>
            </td>
          </tr>
          <tr>
            <td>Amount</td>
            <td>
              <strong>{{
                formattedTransaction().amount
                | currency: formattedTransaction().currencyCountry
              }}</strong>
            </td>
          </tr>
          @if (
            canFetchRelation() &&
            showRefundAmount() &&
            formattedTransaction().transactionType !== 'refund'
            ) {
            <tr>
              <td>Amount Refunded</td>
              <td class="d-flex align-items-center justify-content-start">
            <mat-icon [matTooltip]="
                'Value of accepted refunds against this transaction.'
              " matTooltipPosition="right">info</mat-icon>
                <strong class="ms-2">{{
                  formattedTransaction().amountRefunded || 0
                  | currency: formattedTransaction().currencyCountry
                }}</strong>
              </td>
            </tr>
          }
          @if (
            canFetchRelation() &&
            formattedTransaction().remainingValue !==
            formattedTransaction().amount &&
            formattedTransaction().transactionType !== 'refund' &&
            formattedTransaction().amountRefunded !== undefined
            ) {
            <tr>
              <td>Remaining Value</td>
              <td>
                <strong>{{
                  formattedTransaction().remainingValue
                  | currency: formattedTransaction().currencyCountry
                }}</strong>
              </td>
            </tr>
          }
          <tr>
            <td>Card Number</td>
            <td>
              <strong>{{ formattedTransaction().maskedCard }}</strong>
            </td>
          </tr>
          <tr>
            <td>Card Type</td>
            <td class="d-flex align-items-center justify-content-start">
              <div class="d-flex align-items-center justify-content-center h-100 px-2 rounded"
                style="background-color: #fff; color: black">
                <div style="width: 24px; height: 24px">
                  @if (formattedTransaction().cardIcon.iconType === 'ICON') {
                    <mat-icon class="h-100 d-block">{{
                    formattedTransaction().cardIcon.value }}</mat-icon>
                  }
                  @else {
                    <img class="w-100 h-100 d-block"
                      [src]="formattedTransaction().cardIcon.value"
                      alt="Card scheme logo" />
                  }
                </div>
              </div>
              <strong class="ms-2">{{ formattedTransaction().cardType }}</strong>
            </td>
          </tr>
          <tr>
            <td>Cardholder Name</td>
            <td>
              <strong>{{
                formattedTransaction().cardHolderDetails.name || '-'
              }}</strong>
            </td>
          </tr>
          <tr>
            <td>Identifier</td>
            <td>
              <strong>{{ formattedTransaction().crossReference }}</strong>
            </td>
          </tr>
          @if (canFetchRelation()) {
            <tr>
              <td>Related transactions</td>
              @if (relatedLoading()) {
                <td>
                  <span>Loading...</span>
                </td>
              }
              @if (!relatedLoading() && relatedTransactions().length > 0) {
                <td>
                  @for (r_transaction of relatedTransactions(); track r_transaction) {
                    @if (canShowRelation(r_transaction.crossReference)) {
                      <div
                        class="d-flex align-items-center justify-content-start interactive"
                        (click)="ViewRelatedTransaction(r_transaction)"
                        (keydown.enter)="ViewRelatedTransaction(r_transaction)"
                        tabindex="0"
                        role="button">
                        <odin-chip-status [status]="r_transaction.formattedStatus"
                        [chipClass]="r_transaction.statusIconClass"></odin-chip-status>
                        <span>{{ r_transaction.crossReference }} ({{
                          r_transaction.formattedType
                        }})</span>
                      </div>
                    }
                  }
                </td>
              }
              @if (!relatedLoading() && relatedTransactions().length === 0) {
                <td>
                  <span>No related transactions</span>
                </td>
              }
            </tr>
          }
        </tbody>
      </table>
    </div>
    @if (formattedTransaction() !== undefined) {
      <odin-print-receipt
      [receiptDetail]="createReceipt()"></odin-print-receipt>
    }
    <!-- TRANSACTION ACTIONS -->
    <div class="px-3 d-flex align-items-center justify-content-start gap-2">
    <div [matTooltip]="
        formattedTransaction() === null ||
        formattedTransaction().remainingValue === 0
          ? 'Unable to refund. Maximum refund amount against this transaction has been met.'
          : ''
      ">
        @if (canRefund()) {
<button [disabled]="
          formattedTransaction() === null ||
          formattedTransaction().remainingValue === 0
        " mat-flat-button (click)="startRefundRequest()"
            class="d-flex align-items-center justify-content-between mon-text-danger mon-bg-danger mon-border-danger border" data-test="tx-details-refund-request-button">
            <span>Refund</span>
            <mat-icon>undo</mat-icon>
          </button>
        }
      </div>
    <div [matTooltip]="
        formattedTransaction() === null
          ? 'You can only reverse a transaction made on the same day'
          : ''
      ">
        @if (canReverse()) {
          <button [disabled]="formattedTransaction() === null" mat-flat-button
            (click)="startReverseRequest()"
            class="d-flex align-items-center justify-content-between mon-text-warning mon-bg-warning mon-border-warning border" data-test="tx-details-reverse-request-button">
            <span>Reverse</span>
            <mat-icon>restore</mat-icon>
          </button>
        }
      </div>
    <div [matTooltip]="
        formattedTransaction() === null ? 'Unable to recharge.' : ''
      ">
        @if (canReCharge()) {
          <button [disabled]="formattedTransaction() === null" mat-flat-button
            (click)="startRechargeRequest()"
            class="d-flex align-items-center justify-content-between mon-text-success mon-bg-success mon-border-success border" data-test="tx-details-recharge-request-button">
            <span>Recharge</span>
            <mat-icon>autorenew</mat-icon>
          </button>
        }
      </div>
      <div class="flex-fill"></div>
      @if (canPrint()) {
        <div>
          <button mat-flat-button (click)="printReceipt()"
            class="d-flex align-items-center justify-content-between mon-text-primary mon-bg-primary mon-border-primary border" data-test="tx-details-print-receipt-button">
            <span>Print</span>
            <mat-icon>print</mat-icon>
          </button>
        </div>
      }
      <button mat-stroked-button class="border mon-border-primary text-dark" [mat-dialog-close] cdkFocusInitialf>
        Close
      </button>
    </div>
  </div>
}
